
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';

@Injectable()
export class ReciboService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }
  obter(tipo: string, documento: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `recibo/gerarRecibo/${tipo}/${documento}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

}
